import { ProductInfoForm } from './ProductInfoForm';
import { PublishActionButton } from './PublishActionButton';
// import { MockupTypeSelector } from './MockupTypeSelector';
import { ChannelSelector } from './ChannelSelector';
import { usePublishDesign } from '@/hooks/usePublishDesign';
import { PreviewSummary } from './PreviewSummary';
import { UnpublishedChangesNotice } from './UnpublishedChangesNotice';

/**
 * Full-page layout for Step 3 (Publish).
 */
export function PublishLayout() {
  const { availableChannels, isCloudSession, publishedChannelIds } =
    usePublishDesign();

  // Only shown when there is a choice: one channel, or a cloud session, has
  // its target named on the button instead.
  const showChannelSelector = !isCloudSession && availableChannels.length > 1;

  return (
    <main className="flex-1 overflow-auto bg-[var(--paper)]">
      <div className="mx-auto w-full max-w-7xl p-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-1">
            <PreviewSummary />
          </div>
          <div className="lg:col-span-2 flex flex-col gap-6">
            <UnpublishedChangesNotice />
            <ProductInfoForm />
            {showChannelSelector && (
              <ChannelSelector
                channels={availableChannels}
                publishedChannelIds={publishedChannelIds}
              />
            )}
            <PublishActionButton withImpersonationNotice />
            {/* <MockupTypeSelector /> */}
          </div>
        </div>
      </div>
    </main>
  );
}
